import axios from 'axios';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

const getSignatureRequest = ({ id, companyId }) => {
  return axios.get(`/signature_requests/${id}`, {
    params: {
      company_id: companyId,
    },
  });
};

const getAllSignatureRequests = () => {
  return axios.get(`/signature_requests/get_all_signature_requests`);
};

const getSignatureRequestsByCompanyId = ({ companyId, year, sectionId }) => {
  return axios.get(`/signature_requests/get_signature_requests_by_company_id`, {
    params: {
      company_id: companyId,
      year,
      section_id: sectionId,
    },
  });
};

const deleteSignatureRequestPreview = documentLocation => {
  return axios.get(
    `/signature_requests/delete_signature_request_preview?document_location=${documentLocation}`,
  );
};

const updateSignatureRequest = ({
  companyId,
  id,
  signatures,
  pages,
  formName,
  status,
}) => {
  return axios.post(
    `/signature_requests/update_signature_request`,
    omitBy(
      {
        company_id: companyId,
        id,
        signatures,
        pages,
        form_name: formName,
        status,
      },
      isUndefined,
    ),
  );
};

const sendSignatureRequest = ({
  companyId,
  id,
  documentLocation,
  signatures,
  pages,
  subject,
  message,
  includeWatermark,
  taxYear,
  saveSubjectForFutureUse,
  saveMessageForFutureUse,
}) => {
  return axios.post(`/signature_requests/send_signature_request`, {
    company_id: companyId,
    id,
    document_location: documentLocation,
    signatures,
    pages,
    subject,
    message,
    include_watermark: includeWatermark,
    tax_year: taxYear,
    save_subject_for_future_use: saveSubjectForFutureUse,
    save_message_for_future_use: saveMessageForFutureUse,
  });
};

const sendTaxReturn = ({
  companyId,
  id,
  subject,
  message,
  path,
  documentName,
  saveSubjectForFutureUse,
  saveMessageForFutureUse,
}) => {
  return axios.post(`/signature_requests/send_tax_return`, {
    company_id: companyId,
    id,
    subject,
    message,
    path,
    document_name: documentName,
    save_subject_for_future_use: saveSubjectForFutureUse,
    save_message_for_future_use: saveMessageForFutureUse,
  });
};

const deleteSignatureRequest = ({ id, companyId }) => {
  return axios.post(`/signature_requests/delete_signature_request`, {
    id,
    company_id: companyId,
  });
};

const saveSignature = ({ id, companyId, signature }) => {
  return axios.post(`/signature_requests/save_signature`, {
    id,
    company_id: companyId,
    signature,
  });
};

const getFormDefinitions = () => {
  return axios.get(`/signature_requests/get_form_definitions`);
};

const downloadPdf = ({ id, companyId, includeSignatures }) => {
  return axios.post(`/signature_requests/download_pdf`, {
    id,
    company_id: companyId,
    include_signatures: includeSignatures,
  });
};

const cancelProcessing = ({ id, companyId }) => {
  return axios.post(`/signature_requests/cancel_processing`, {
    id,
    company_id: companyId,
  });
};

export default {
  getSignatureRequest,
  getAllSignatureRequests,
  getSignatureRequestsByCompanyId,
  updateSignatureRequest,
  sendSignatureRequest,
  deleteSignatureRequest,
  saveSignature,
  deleteSignatureRequestPreview,
  getFormDefinitions,
  downloadPdf,
  sendTaxReturn,
  cancelProcessing,
};
